import photoAdapter from '@/features/listing/requests/adapters/photo-adapter';
import { type UserResponse } from '@/features/user/types/user-response-types';
import {
  GENDERS_KEYS,
  type User,
  UserVerifications,
} from '@/features/user/types/user-types';
import { type ImageThumbnail } from '@/shared/types/image-thumbnail-types';

export default function userAdapter(userResponse: UserResponse): User {
  const {
    age,
    contact_phone,
    description,
    dob,
    email,
    first_name,
    full_access,
    gender,
    id,
    last_name,
    member_since,
    photos,
    spoken_languages,
    verified,
    verified_with,
  } = userResponse;

  // Before verified_with always was an array, but now it can be null, that's an empty array set if it is null
  const usersVerifications = verified_with ?? [];

  let userPhotos: ImageThumbnail[] | null = null;

  if (photos.length > 0) {
    userPhotos = photos.map((photo) => photoAdapter(photo));
  }

  // user ID verification came from dedicated endpoint and added to user object dynamically
  return {
    about: description,
    age,
    avatar: photoAdapter(photos[0]),
    birthDate: dob,
    email,
    firstName: first_name,
    gender: gender in GENDERS_KEYS ? gender : null,
    id,
    isPaidAccount: full_access,
    lastName: last_name,
    phoneData: contact_phone ? {
      countryCode: contact_phone.country_code,
      countryId: contact_phone.country_id,
      isVisible: contact_phone.is_visible,
      phone: contact_phone.phone,
    } : null,
    photos: userPhotos,
    registerDate: member_since,
    spokenLanguages: spoken_languages,
    verifications: {
      apple: usersVerifications.includes(UserVerifications.Apple),
      email: usersVerifications.includes(UserVerifications.Email),
      facebook: usersVerifications.includes(UserVerifications.Facebook),
      google: usersVerifications.includes(UserVerifications.Google),
      instagram: usersVerifications.includes(UserVerifications.Instagram),
      linkedIn: usersVerifications.includes(UserVerifications.LinkedIn),
      phone: usersVerifications.includes(UserVerifications.Phone),
    },
    isVerified: verified,
  };
}
